import createClient from "openapi-fetch";
import { serviceURL } from "../../utils/service-url";

import type { paths } from "../../__definitions__/slack-admin.changeengine.com-definitions";

export const slackAdmin = createClient<paths>({
  baseUrl: serviceURL("slack-admin"),
  headers: {
    "Content-Type": "application/json",
  },
});
